/*
  Shared cart state.

  Four independent components each fetched /cart.js on init, so a cold page
  load made four identical round trips before anything could use the result.
  This collapses them into one.

  Two layers:
    - in-flight coalescing: concurrent callers share a single request
    - a short freshness window: a call within FRESH_MS of the last response
      reuses it rather than refetching

  The window is deliberately small. A cart is mutable state, so this is a
  burst de-duplicator, not a cache — anything that changes the cart must call
  OB.invalidateCart(), and the theme's own cart events do that below.

  Usage:
    window.OB.getCart().then(function (cart) { ... });
    window.OB.invalidateCart();            // after add/update/remove
*/
(function () {
  var FRESH_MS = 1500;

  var pending = null;   // promise for the request currently in flight
  var cached = null;    // last successful cart payload
  var cachedAt = 0;

  window.OB = window.OB || {};

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('cart.js responded ' + res.status);
      return res.json();
    });
  }

  window.OB.getCart = function (options) {
    var force = Boolean(options && options.force);

    if (!force && cached && Date.now() - cachedAt < FRESH_MS) {
      return Promise.resolve(cached);
    }

    if (pending) return pending;

    pending = fetchCart()
      .then(function (cart) {
        cached = cart;
        cachedAt = Date.now();
        pending = null;
        return cart;
      })
      .catch(function (err) {
        // Don't poison the next caller with a failed request.
        pending = null;
        throw err;
      });

    return pending;
  };

  window.OB.invalidateCart = function () {
    cached = null;
    cachedAt = 0;
  };

  // The theme signals a cart change through these. Each one means the cached
  // copy is stale, so drop it — the next getCart() goes back to the network.
  ['updateCart', 'refreshDrawer', 'cart:updated'].forEach(function (name) {
    document.addEventListener(name, window.OB.invalidateCart);
  });
})();
